
















import { Component, Vue, Prop } from "vue-property-decorator";
import store from '@/store';
import { Section } from "@/common/interface";

@Component
export default class ActivitySection extends Vue {
  @Prop() title!: string; // 标题
  @Prop({ default: true }) showTitle!: boolean;

  get sectionConf() {
    return store.getters.section;
  }

}
